<template>
  <v-container fluid>
    <v-row justify="start" align="start">
      <v-col
        cols="12"
        xl="2"
        sm="5"
        md="5"
        v-for="(tile, index) in tiles"
        :key="index"
      >
        <v-card
          elevation="3"
          class="pa-4 d-flex justify-center align-center"
          :style="{
            cursor: tile.disabled ? 'not-allowed' : 'pointer',
            height: '200px',
            opacity: tile.disabled ? 0.5 : 1,
          }"
          @click="!tile.disabled && openInNewTab(tile.url)"
        >
          <v-col cols="10" class="text-center">
            <v-card-title class="text-center" style="white-space: normal; display: block;">
              <div v-if="tile.name">
                <div class="text-h4 font-weight-bold">
                  {{ tile.name }}
                </div>
              </div>
            </v-card-title>

            <v-card-subtitle
              v-if="tile.subtitle"
              class="text-center"
              style="white-space: normal;"
            >
              {{ tile.subtitle }}
            </v-card-subtitle>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';
import KeyCloakService from "./../security/KeycloakService";

@Options({
  components: {}
})
export default class DashboardView extends Vue {
  private tiles: any[] = [];

  private openInNewTab(url: string) {
    window.open(url, '_blank');
  }

  async created() {
    try {
      // Get user token (assuming GetUserApps() returns or includes a token)
      const token = KeyCloakService.GetAccesToken();

      // Fetch user sites
      const response = await axios.get("https://api.odb.portal.ahmadiyya.de/api/sites", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.data && response.data.status === "success" && Array.isArray(response.data.data)) {
        // Map API data to tile objects
        const siteTiles = response.data.data.map((site: any) => ({
          name: site.name,
          subtitle: site.subtitle,
          url: site.link
        }));

        this.tiles.push(...siteTiles);
      }

      // Handle EMS access logic
      //@ts-ignore
      const apps = KeyCloakService.GetUserApps();
      //@ts-ignore
      if (apps.includes("EMS")) {
        this.tiles.push({
          name: 'Expense Management System',
          subtitle: '(VPN benötigt)',
          url: 'https://expense.fra.ahmadiyya.de'
        });
      }

    } catch (error) {
    }
  }
}
</script>
